export default __webpack_public_path__ + "static/media/model_training.a7897a8e.png";